import React from 'react';
import { Routes, Route } from 'react-router-dom';
import LandingPage from './pages/LandingPage';
import Assessment from './pages/Assessment';
import Guide from './pages/Guide';

function App() {
  return (
    <Routes>
      <Route path="/" element={<LandingPage />} />
      <Route path="/assess" element={<Assessment />} />
      <Route path="/guide" element={<Guide />} />
    </Routes>
  );
}

export default App;
